import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import FetchCall from '../../API/FetchCall';
import { getParentsPaged } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { getTotalParents, adminUser, userExport, deactivateUser, activateUser, commonAPI } from '../../API/FetchCall';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import BeWiseLoading from '../../../src/assets/bewiseloading.gif';


class parentList extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
         this.state = {
              confirmModal: false,
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location:  localStorage.getItem("location")? localStorage.getItem("location"):'Bengaluru',
              parentList: [],
              exportbtndisabled:false,  
              thisExportBtnText:'Export',
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
              monthList: [{ no: 1, mon: 'Jan' }, { no: 2, mon: 'Feb' }, { no: 3, mon: 'Mar' }, { no: 4, mon: 'Apr' },
            { no: 5, mon: 'May' }, { no: 6, mon: 'Jun' }, { no: 7, mon: 'Jul' }, { no: 8, mon: 'Aug' },
            { no: 9, mon: 'Sep' }, { no: 10, mon: 'Oct' }, { no: 11, mon: 'Nov' }, { no: 12, mon: 'Dec' }],
        };

         
    }


    componentDidMount() {

        var THIS = this;

        $(document).on('click', '.remove_user', function () {
            var delete_id = $(this).data("id");
            THIS.setState({
                delete_id: delete_id
            });
            THIS.deletUser(delete_id);
        });
        $(document).on('click', '.activate_user', function () {
            var add_id = $(this).data("id");
            THIS.setState({
                add_id: add_id
            });
            THIS.activateUser(add_id);
        });

        $(document).on('click', '.sendotp_user', function () {
            var add_id = $(this).data("id");
           
            THIS.sendOTPUser(add_id);
        });


      this.getTotal('parents');
      this.getList();

    }



    getTotal = (vertical, location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalParents(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }      

    sendOTPUser(add_id = '') {
            alert("OTP sent");
    }

    activateUser(add_id = '') {
         if(confirm("Are you sure to Activate this user?")===true){
                let ins = JSON.stringify({
                    id: add_id,
                    type: 4
                });
                activateUser(ins).then((res) => {
                    let toastr = '';
                    if (res.status === 1) {
                        alert("Activated"); 
                        setTimeout(function () {
                            window.location.reload();
                        }, 2000);
                    } else {
                       alert("Error!"); 
                    }
                });
            }
        
    }
    deletUser(delete_id = '') {
        if(confirm("Are you sure to Deactivate this user?")===true){
                let ins = JSON.stringify({
                    id: delete_id,
                    type: 4
                });
                deactivateUser(ins).then((res) => {
                     
                    if (res.status === 1) {
                        alert("Deactivated"); 
                        setTimeout(function () {
                            window.location.reload();
                        }, 2000);
                    } else {
                        alert("Error removing"); 
                    }
                });
            }
    }

    handleChangeN = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    } 

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }   

    filterShow  = async () => {

      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        login_id: login_id,
        role: role,
        location: this.state.location,
        year: this.state.year,
        month: this.state.month,
      });
      getParentsPaged(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            parentList: res.user_list
            
          });
        } else {
          this.setState({
            parentList: [],
          });
        }
      });

    }

  exportExcel = (e) => {
      this.userExport();
  }

  userExport = async () => {
      try {
          let req = JSON.stringify({
              location: this.state.location,
              year: this.state.year,
              month: this.state.month,
          })
          const res = await userExport(req);
          if (res.status == 1) {
              window.open(res.path);
              // window.location.href(res.path)
          }
      } catch (error) {
          this.setState({ error: true });
      }
  };

    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getParentsPaged(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            parentList: res.user_list
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            parentList: [],
          });
        }
      });


    }     

    render() {

        const { parentList, exportbtndisabled} = this.state;
        const { currentPage, PER_PAGE, totalCount, total } = this.state;
        const year = 2019;
        const years = Array.from(new Array(10), (val, index) => index + year);

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Parents</h4>
                                   
                  <div class="float-right">&nbsp;<button disabled={exportbtndisabled} class="btn btn-primary btn-sm"  onClick={() => this.exportExcel()}>{this.state.thisExportBtnText}</button> </div>
                  <p class="card-description">
                    <div class="cityselection">
                     
                    <div class="leftaligned">
                    <select name="location" class="form-control" onChange={(e) => this.handleChangeN(e)}
                                                       value={this.state.location}>
                            <option value="">select city</option>
                            <option value="Bengaluru">Bengaluru</option>
                            <option value="Chennai">Chennai</option>
                            <option value="Indore">Indore</option>
                            <option value="Hosur">Hosur</option>
                            <option value="Coimbatore">Coimbatore</option>
                            <option value="Madurai">Madurai</option>
                            <option value="Mysore">Mysore</option>
                            <option value="Mumbai">Mumbai</option>
                            <option value="Kolkata">Kolkata</option>
                            <option value="New Delhi">New Delhi</option>
                            <option value="Jaipur">Jaipur</option>
                            <option value="Chandigarh">Chandigarh</option>
                            <option value="Pune">Pune</option>
                            <option value="Kochi">Kochi</option>
                            <option value="Indore">Indore</option>
                            <option value="Noida">Noida</option>
                            <option value="Agra">Agra</option>
                            <option value="Puducherry">Puducherry</option>
                            <option value="Tiruchirappalli">Tiruchirappalli</option>
                        </select>
                     
                      </div>

                      <div class="leftaligned">
                      <select className='form-control selectpicker' onChange={this.handleChangeN}
                                                        name='year' title='Select Years' value={this.state.year}>
                                                        <option value={''}>Select Year</option>
                                                        {years.map((item, i) => {
                                                            return (
                                                                <option value={item}>{item}</option>
                                                            )
                                                        })}

                      </select>
                      </div>
                      <div class="leftaligned">
                      <select className='form-control selectpicker' onChange={this.handleChangeN}
                                                        name='month' title='Select Month' value={this.state.month}>
                                                        <option value={''}>Select Month</option>
                                                        {this.state.monthList.map((item, i) => {
                                                            return (
                                                                <option value={item.no}>{item.mon}</option>
                                                            )
                                                        })}
                      </select>
                      </div>
                      <div class="leftaligned">
                        <button class="btn btn-primary btn-sm" onClick={this.filterShow}>show</button>
                      </div>
                       
                    </div>
                  </p>

                  <div class="table-responsive pt-3">
                     <table id="tablebw">
                      <thead class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          <th>
                            <strong>Update Date</strong>
                          </th>
                          <th>
                            <strong>First Name</strong>
                          </th>
                          <th>
                            <strong>Last Name</strong>
                          </th>
                         
                          <th>
                            <strong>Email Id</strong>
                          </th>


                          <th>
                            <strong>Mobile number</strong>
                          </th>

                          
                          <th>
                            <strong>City</strong>
                          </th>
                         
                          <th>
                            <strong>Status</strong>
                          </th>
                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {parentList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          <td>
                           {item.created_date}
                          </td>
                          <td>
                           {item.first_name}
                          </td>
                          <td>
                            {item.last_name}
                          </td>
                          
                          <td>
                           {item.email_id}
                          </td>
                          <td>
                            {item.mobile_no}
                          </td>
                          <td>
                            {item.city}
                          </td>
                          
                           
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                          
                          <td dangerouslySetInnerHTML={{__html: item.action}} />                            

                        </tr>

                      })

                      }

{parentList.length==0 && 

<tr><td colspan="9">No data</td></tr>


}
                       
                      </tbody>
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                  </div>
                </div>
              </div>
            </div>


          

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default parentList;


// WEBPACK FOOTER //
// ./src/components/bewise/parentList.jsx